import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  filters: [],
  isLoading: false,
  success: false,
  error: null,
};

export const filterReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("filtersRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("filtersSuccess", (state, action) => {
      state.isLoading = false;
      state.filters = action.payload;
    })
    .addCase("filtersFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("createFilterRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("createFilterSuccess", (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.filters.push(action.payload);
    })
    .addCase("createFilterFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("updateFilterRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("updateFilterSuccess", (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.filters = state.filters.map((filter) =>
        filter._id === action.payload._id ? action.payload : filter
      );
    })
    .addCase("updateFilterFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("deleteFilterRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("deleteFilterSuccess", (state, action) => {
      state.isLoading = false;
      state.filters = state.filters.filter(
        (filter) => filter._id !== action.payload
      );
    })
    .addCase("deleteFilterFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("clearErrors", (state) => {
      state.error = null;
    });
});
